import React from 'react';
import { AppStore } from '../Core/AppStore';
import { Storage } from '../Core/Storage';
import { CatalogueProvider } from '../Providers/CatalogueProvider';
import { Constants } from '../Core/Constants'
import AddToCart from './../Components/AddToCart.jsx';


export default class CartProducts extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			products: []
		};
	}

	componentDidMount = () => {;
		CatalogueProvider.getProductBuyWith((data) => {
			this.setState({ products: data });
		});
	}

	parseHtml = (html) => {
		var div = window.document.createElement("div");
		div.innerHTML = html;
		return div.innerText;
    }

	render() {
		var T = window.Texts.cart;
		const products = this.state.products;
		if (!products || products.length < 1)
			return null;
		return (
			<>
				<div className="headline">
					<h2>{T.otherCustomersBuy}</h2>
				</div>
				<div className="prow products-row four-in-row">
					{products.map((product) => {
						return (<div className="pcol" key={'cartproducts-' + product.id}>
							<div className="product-item">
								<div className="thumb">
									<div className="thumb-img">
										<div className="viewSale">-{product.priceTable.displayDiscountPerCent}</div>
										<a href={product.url}>
											<img src={product.thumb.url} alt={product.thumb.name} height="170" width="170" />
										</a>
									</div>
								</div>
								<div className="details">
									<div className="desc" style={{ height: '131px' }}>
										<h3><a href={product.url}><u>{product.name}</u></a></h3>
										<p>{this.parseHtml(product.description)}</p>
										<span>{T.productCode}: {product.code}</span>
									</div>
									<div className="add2cart">
										<div className="inner">
											<ul>
												<li className="amount-in-store" dangerouslySetInnerHTML={{ __html: product.displayAvailability }}></li>
												<li className="price"><strong>{product.priceTable.displayTotalPriceInclVat}</strong> {T.withTax}
													{(product.priceTable.DiscountPerCent > 0 && product.strikedOutPriceEnabled)?												
													<span className="old-price">
														<span className="percentage">-{product.priceTable.displayDiscountPerCent}</span>&nbsp;
														<span className="vire-price">{product.priceTable.displayBasePriceInclVat + ' **'}</span>
													</span>:null}
												</li>
											</ul>
											<AddToCart var product={{ id: product.id, name: product.name, picture: product.thumb.url, price: product.priceTable.displayTotalPriceInclVat, url: product.url }} />
										</div>
									</div>
								</div>
							</div>
						</div>);
					})}
				</div>
			</>
		);
	}
}

